import { AxiosError } from 'axios';

import Button from '@/v2/components/Button/Button';
import StatusCodes from '@/v2/constants/StatusCodes';
import useResendVerificationEmailMutation from '@/v2/domains/Auth/queries/useResendVerificationEmailMutation.hook';

import useResendCooldown from './useResendCooldown.hook';

export default function ResendVerificationEmailButton() {
  const { secondsLeft, startCooldown } = useResendCooldown();
  const { mutate, isPending } = useResendVerificationEmailMutation();

  const onError = (error: AxiosError) => {
    if (error.response?.status == StatusCodes.TOO_MANY_REQUESTS) {
      startCooldown();
    }
  };

  const resend = () => mutate(undefined, { onSuccess: startCooldown, onError });

  const label = secondsLeft ? `Resend email (${secondsLeft}s)` : 'Resend email';

  return (
    <Button
      size="large"
      block
      onClick={resend}
      loading={isPending}
      disabled={isPending || !!secondsLeft}
    >
      {label}
    </Button>
  );
}
